export default __webpack_public_path__ + "static/comment-2d70b51e8d6da374ade1b9425b884b83.jpg";